import React from "react";
import cn from "classnames";
import { useNavigate, useLocation } from "react-router-dom";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import Button from "../../../../components/Buttons/button";
// import { formatedAmount } from "../../../../utils/helpers";
import { useFormattedAmount } from "../../../../hooks/useFormattedAmount";

function PillCards({
  setPopup,
  setState,
  data,
  id,
  setDashboard,
  totalTeamCost,
  averageTeamCost,
  totalMonthlyExpenses,
  totalExpensesCount,
}) {
  const location = useLocation();
  const navigate = useNavigate();
  const formatFunction = useFormattedAmount();

  return (
    <SkeletonTheme baseColor="#3B4255" highlightColor="#0000001a">
      <div className="flex flex-col gap-[32px]">
        <div className="flex justify-between items-center gap-[32px]">
          <div className="flex justify-between items-center w-[100%] h-[100px] p-[24px] gap-[16px] bg-[#363D50] rounded-[32px]">
            <div className="flex flex-col gap-[6px] w-[203px] h-[51px]">
              {data?.monthly_cost !== undefined && (
                <span className="text-primary !text-[18px]">
                  {formatFunction(data?.monthly_cost)}
                </span>
              )}
              {data?.monthly_cost === undefined && (
                <Skeleton className="!w-[132px]" />
              )}
              {data?.name && (
                <span className="text-secondary !leading-[21px] whitespace-nowrap">
                  {data?.name}'s cost this month
                </span>
              )}
              {!data?.name && <Skeleton className="!w-[132px]" />}
            </div>
            <Button
              onClick={() => {
                setPopup(true);
                setState(24);
              }}
              secondary
              hoverColor
            >
              History
            </Button>
          </div>
          <div className="flex justify-between items-center w-[100%] h-[100px] p-[24px] gap-[16px] bg-[#363D50] rounded-[32px]">
            <div className="flex items-center gap-4">
              <div className="rounded-2xl p-2 bg-[#242B3E]">
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.6665 8.00163C4.6665 6.1611 6.15846 4.66699 7.99984 4.66699H23.9998C25.8412 4.66699 27.3332 6.1611 27.3332 8.00163V26.7531C27.3332 27.8154 26.1486 28.4563 25.2602 27.864L23.1079 26.4292C22.8664 26.2681 22.5484 26.2819 22.3217 26.4633L20.5826 27.8546C19.8521 28.4389 18.8142 28.4389 18.0838 27.8546L16.4163 26.5206C16.1728 26.3258 15.8269 26.3258 15.5834 26.5206L13.9159 27.8546C13.1855 28.4389 12.1476 28.4389 11.4171 27.8546L9.67802 26.4633C9.45132 26.2819 9.13332 26.2681 8.89176 26.4292L6.73944 27.864C5.85112 28.4563 4.6665 27.8154 4.6665 26.7531V8.00163ZM7.99984 6.00033C6.89569 6.00033 5.99984 6.89664 5.99984 8.00163V26.7531L8.15216 25.3198C8.87684 24.8366 9.83085 24.878 10.5109 25.4221L12.25 26.8134C12.4935 27.0082 12.8395 27.0082 13.083 26.8134L14.7504 25.4794C15.4809 24.8951 16.5188 24.8951 17.2492 25.4794L18.9167 26.8134C19.1602 27.0082 19.5062 27.0082 19.7496 26.8134L21.4887 25.4221C22.1688 24.878 23.1228 24.8366 23.8475 25.3198L25.9992 26.7542L25.9998 8.00163C25.9998 6.89664 25.104 6.00033 23.9998 6.00033H7.99984ZM9.99984 12.0003C9.99984 11.6321 10.2983 11.3337 10.6665 11.3337H16.6665C17.0347 11.3337 17.3332 11.6321 17.3332 12.0003C17.3332 12.3685 17.0347 12.667 16.6665 12.667H10.6665C10.2983 12.667 9.99984 12.3685 9.99984 12.0003ZM19.9998 12.0003C19.9998 11.6321 20.2983 11.3337 20.6665 11.3337H21.3332C21.7014 11.3337 21.9998 11.6321 21.9998 12.0003C21.9998 12.3685 21.7014 12.667 21.3332 12.667H20.6665C20.2983 12.667 19.9998 12.3685 19.9998 12.0003ZM9.99984 17.3337C9.99984 16.9655 10.2983 16.667 10.6665 16.667H21.3332C21.7014 16.667 21.9998 16.9655 21.9998 17.3337C21.9998 17.7018 21.7014 18.0003 21.3332 18.0003H10.6665C10.2983 18.0003 9.99984 17.7018 9.99984 17.3337Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div className="flex flex-col gap-[6px] w-[203px] h-[51px]">
                {data?.monthly_cost !== undefined && (
                  <span className="text-primary !text-[18px]">
                    {formatFunction(totalMonthlyExpenses)}
                  </span>
                )}
                {data?.monthly_cost === undefined && (
                  <Skeleton className="!w-[132px]" />
                )}
                <span className="text-secondary !leading-[21px] whitespace-nowrap">
                  {totalExpensesCount} expenses this month
                </span>
              </div>
            </div>
            {totalExpensesCount > 0 && (
              <Button
                onClick={() => {
                  setPopup(true);
                  setState(59);
                }}
                secondary
                hoverColor
              >
                View
              </Button>
            )}
          </div>
        </div>

        {data && data.also_manager && (
          <div className="flex flex-wrap justify-center xl:justify-between items-center gap-[32px]">
            <div className="flex justify-center items-center flex-col w-[340px] md:w-[321px] lg:w-[321px] xl:w-[270px] 2xl:w-[270px] h-[100px] p-[24px] gap-[10px] bg-[#363D50] rounded-[32px] flex_card">
              <span className="text-primary !text-[18px]">
                {formatFunction(totalTeamCost)}
              </span>
              {totalTeamCost === undefined && (
                <Skeleton className="!w-[132px]" />
              )}
              <span className="text-secondary !leading-[21px]">
                Total Team Cost
              </span>
            </div>
            <div className="flex justify-center items-center flex-col w-[340px] md:w-[321px] lg:w-[321px] xl:w-[270px] 2xl:w-[270px] h-[100px] p-[24px] gap-[10px] bg-[#363D50] rounded-[32px] flex_card">
              {averageTeamCost !== undefined && (
                <span className="text-primary !text-[18px]">
                  {formatFunction(averageTeamCost)}
                </span>
              )}
              {averageTeamCost === undefined && (
                <Skeleton className="!w-[132px]" />
              )}
              <span className="text-secondary !leading-[21px]">
                Average Team Cost
              </span>
            </div>
            <div className="flex justify-center items-center w-[340px] md:w-[321px] lg:w-[321px] xl:w-[270px] 2xl:w-[270px] h-[100px] p-[24px] gap-[16px] bg-[#363D50] rounded-[32px] text-[#FFD74A] flex_card">
              {location.pathname.includes("/company_dashboard") ? (
                <Button
                  onClick={() => {
                    navigate(`/company_dashboard/employees/${data.id}`);
                  }}
                  secondary={true}
                  hoverColor={true}
                >
                  View
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    navigate(`/personal_dashboard/teams/${data.id}`);
                  }}
                  secondary={true}
                  hoverColor={true}
                >
                  View
                </Button>
              )}
            </div>
          </div>
        )}

        <div className="flex flex-wrap justify-center xl:justify-between items-center gap-[32px]">
          <div className="flex justify-between items-center w-[340px] md:w-[321px] lg:w-[321px] xl:w-[270px] 2xl:w-[270px] h-[100px] p-[24px] gap-[16px] bg-[#363D50] rounded-[32px] flex_card">
            <div className="flex justify-center items-center bg-[#242B3E] p-[8px] rounded-[16px] w-[48px] h-[48px] gap-[10px]">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M4.66634 9.33333C4.66634 8.22876 5.56177 7.33333 6.66634 7.33333H25.333C26.4376 7.33333 27.333 8.22876 27.333 9.33333V20C27.333 21.1046 26.4376 22 25.333 22H19.7709C18.8869 22 18.039 22.3512 17.4139 22.9763L12.1949 28.1953C11.9346 28.4556 11.9346 28.8777 12.1949 29.1381C12.4553 29.3984 12.8774 29.3984 13.1377 29.1381L18.3567 23.9191C18.7318 23.544 19.2405 23.3333 19.7709 23.3333H25.333C27.174 23.3333 28.6663 21.8409 28.6663 20V9.33333C28.6663 7.49238 27.174 6 25.333 6H6.66634C4.82539 6 3.33301 7.49238 3.33301 9.33333V20C3.33301 21.8409 4.82539 23.3333 6.66634 23.3333H11.333C11.7012 23.3333 11.9997 23.0349 11.9997 22.6667C11.9997 22.2985 11.7012 22 11.333 22H6.66634C5.56177 22 4.66634 21.1046 4.66634 20V9.33333ZM10.6663 14C10.2982 14 9.99967 14.2985 9.99967 14.6667C9.99967 15.0349 10.2982 15.3333 10.6663 15.3333H10.6797C11.0479 15.3333 11.3463 15.0349 11.3463 14.6667C11.3463 14.2985 11.0479 14 10.6797 14H10.6663ZM15.9997 14C15.6315 14 15.333 14.2985 15.333 14.6667C15.333 15.0349 15.6315 15.3333 15.9997 15.3333H16.013C16.3812 15.3333 16.6797 15.0349 16.6797 14.6667C16.6797 14.2985 16.3812 14 16.013 14H15.9997ZM21.333 14C20.9648 14 20.6663 14.2985 20.6663 14.6667C20.6663 15.0349 20.9648 15.3333 21.333 15.3333H21.3463C21.7145 15.3333 22.013 15.0349 22.013 14.6667C22.013 14.2985 21.7145 14 21.3463 14H21.333Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="flex flex-col gap-[6px] w-[203px] h-[51px]">
              {data?.requests_count !== undefined && (
                <span className="text-primary !text-[18px]">
                  {data?.requests_count}
                </span>
              )}
              {data?.requests_count === undefined && (
                <Skeleton className="!w-[132px]" />
              )}
              <span className="text-secondary !leading-[21px]">
                Requests Made
              </span>
            </div>
            <Button
              className={cn({
                invisible: !data?.requests_count,
              })}
              onClick={() => {
                setPopup(true);
                setState(15);
                setDashboard("companyDahboard");
              }}
              secondary
              hoverColor
            >
              View
            </Button>
          </div>

          <div className="flex justify-between items-center w-[340px] md:w-[321px] lg:w-[321px] xl:w-[270px] 2xl:w-[270px] h-[100px] p-[24px] gap-[16px] bg-[#363D50] rounded-[32px] flex_card">
            <div className="flex justify-center items-center bg-[#242B3E] p-[8px] rounded-[16px] w-[48px] h-[48px] gap-[10px]">
              <svg
                width="33"
                height="33"
                viewBox="0 0 33 33"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M9.91063 9.66914C10.727 9.16154 11.7229 9.03114 12.6424 9.3114L19.3491 11.3554C20.2688 11.6357 20.7217 12.6703 20.3039 13.5362C19.9788 14.2099 19.223 14.56 18.4989 14.3725L15.1335 13.5006C15.0657 13.4823 14.9972 13.4752 14.9301 13.4783C14.728 13.4874 14.5407 13.5888 14.4222 13.7507C14.3787 13.8101 14.3445 13.8777 14.3222 13.9519C14.2997 14.026 14.2909 14.1013 14.2943 14.1748C14.3065 14.4446 14.483 14.6879 14.7485 14.7766L17.4288 15.7024C18.321 16.0105 19.2856 16.0409 20.1954 15.7895L27.3649 13.8084C27.8684 13.6693 28.4053 13.8576 28.7115 14.2807C29.1229 14.8491 28.9865 15.6446 28.4092 16.0435L19.9792 21.8671C19.1671 22.4281 18.1482 22.6003 17.1968 22.3374L9.8707 20.313C9.46585 20.2012 9.04776 20.1445 8.62774 20.1445H5.31011C4.94192 20.1445 4.64345 20.4429 4.64345 20.8111C4.64345 21.1793 4.94192 21.4778 5.31011 21.4778H8.62774C8.92776 21.4778 9.22639 21.5183 9.51557 21.5982L16.8417 23.6226C18.1736 23.9907 19.6001 23.7495 20.7371 22.9641L29.167 17.1405C30.3596 16.3166 30.6415 14.6732 29.7917 13.4989C29.159 12.6248 28.0499 12.2358 27.0098 12.5232L21.5426 14.0339C22.2493 12.4487 21.4109 10.5899 19.7378 10.08L13.0312 8.03599C11.7437 7.64362 10.3496 7.82618 9.20662 8.53682L4.31475 11.5783C4.00207 11.7727 3.90619 12.1838 4.1006 12.4965C4.295 12.8091 4.70608 12.905 5.01876 12.7106L9.91063 9.66914Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="flex flex-col gap-[6px] w-[203px] h-[51px]">
              {data?.feedbacks_count !== undefined && (
                <span className="text-primary !text-[18px]">
                  {data?.feedbacks_count}
                </span>
              )}
              {data?.feedbacks_count === undefined && (
                <Skeleton className="!w-[132px]" />
              )}
              <span className="text-secondary !leading-[21px]">
                Feedback given
              </span>
            </div>
            <Button
              className={cn({
                invisible: !data?.feedbacks_count,
              })}
              onClick={() => {
                setPopup(true);
                setState(16);
                setDashboard("companyDahboard");
              }}
              secondary
              hoverColor
            >
              View
            </Button>
          </div>
          <div className="flex justify-between items-center w-[340px] md:w-[321px] lg:w-[321px] xl:w-[270px] 2xl:w-[270px] h-[100px] p-[24px] gap-[16px] bg-[#363D50] rounded-[32px] flex_card">
            <div className="flex justify-center items-center bg-[#242B3E] p-[8px] rounded-[16px] w-[48px] h-[48px] gap-[10px]">
              <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.6059 4.70986C20.2321 4.3058 20.9162 4.07833 21.6469 4.07833C22.1174 4.07833 22.5085 4.1881 22.8213 4.36124C23.1624 4.55004 23.5919 4.42662 23.7807 4.08556C23.9695 3.7445 23.8461 3.31496 23.505 3.12615C22.9711 2.83058 22.3426 2.66663 21.6469 2.66663C20.6087 2.66663 19.6626 2.99319 18.8405 3.52365C18.5129 3.73501 18.4187 4.17188 18.6301 4.49945C18.8414 4.82701 19.2783 4.92122 19.6059 4.70986ZM25.1227 5.14139C25.0111 4.76787 24.6179 4.55552 24.2444 4.66709C23.8708 4.77867 23.6585 5.17192 23.7701 5.54544C23.8796 5.91205 23.8916 6.31894 23.7868 6.72551C23.7018 7.0552 23.5757 7.31954 23.4238 7.529C23.2507 7.76764 23.2487 8.07824 23.3944 8.31448H23.2496C23.0641 8.14892 22.7967 8.08656 22.5454 8.17465C22.2893 8.26447 21.9896 8.31443 21.6469 8.31443C21.257 8.31443 20.941 8.63045 20.941 9.02029C20.941 9.41012 21.257 9.72614 21.6469 9.72614C21.715 9.72614 21.7828 9.72472 21.8502 9.72187C21.8759 9.72472 21.9021 9.72618 21.9286 9.72618H24.4697C25.132 9.72618 25.5392 9.85878 25.7974 10.0253C26.125 10.2366 26.5619 10.1422 26.7731 9.81462C26.9844 9.487 26.8901 9.05015 26.5624 8.83888C26.0387 8.50116 25.3837 8.33201 24.5966 8.31577C24.8487 7.95656 25.0344 7.54081 25.1538 7.07796C25.3223 6.42428 25.3062 5.7558 25.1227 5.14139ZM17.5638 6.98574C17.7557 6.64642 17.6362 6.21577 17.2969 6.02387C16.9576 5.83196 16.5269 5.95147 16.335 6.29079C16.2086 6.5144 16.0906 6.74351 15.9814 6.97661C15.873 6.74986 15.757 6.52674 15.6335 6.30865C15.4415 5.96941 15.0108 5.85009 14.6715 6.04214C14.3323 6.2342 14.213 6.66489 14.405 7.00413C14.6413 7.42144 14.8476 7.86293 15.0214 8.31448H13.4584C13.0686 8.31448 12.7526 8.6305 12.7526 9.02033C12.7526 9.41016 13.0686 9.72618 13.4584 9.72618H15.9858C15.9951 9.72636 16.0044 9.72637 16.0137 9.72618H18.5405C18.9304 9.72618 19.2464 9.41016 19.2464 9.02033C19.2464 8.6305 18.9304 8.31448 18.5405 8.31448H16.9532C17.1194 7.85724 17.3243 7.40926 17.5638 6.98574ZM8.57636 7.529C8.74948 7.76764 8.7515 8.07824 8.60571 8.31448H8.75055C8.93602 8.14892 9.20351 8.08656 9.45471 8.17465C9.71085 8.26447 10.0105 8.31443 10.3533 8.31443C10.7431 8.31443 11.0591 8.63045 11.0591 9.02029C11.0591 9.41012 10.7431 9.72614 10.3533 9.72614C10.2848 9.72614 10.2168 9.72471 10.1491 9.72183C10.1232 9.7247 10.097 9.72618 10.0703 9.72618H7.52926C6.86693 9.72618 6.45981 9.85878 6.20159 10.0253C5.87396 10.2366 5.43711 10.1422 5.22584 9.81462C5.01458 9.487 5.1089 9.05015 5.43652 8.83888C5.96051 8.50099 6.61595 8.33184 7.40356 8.31575C7.15145 7.95654 6.96572 7.5408 6.84639 7.07796C6.67785 6.42428 6.69391 5.7558 6.87745 5.14139C6.98902 4.76787 7.38227 4.55552 7.75579 4.66709C8.12932 4.77867 8.34167 5.17192 8.23009 5.54544C8.12058 5.91205 8.10856 6.31894 8.21339 6.72551C8.29839 7.0552 8.42442 7.31954 8.57636 7.529ZM27.9263 11.3907C27.8795 11.0036 27.5279 10.7278 27.1409 10.7745C26.7539 10.8213 26.478 11.1729 26.5248 11.5599C26.5863 12.0695 26.5873 12.6355 26.5873 13.2554C26.5873 13.811 26.5869 14.3278 26.5521 14.801C26.5235 15.1898 26.8155 15.5281 27.2043 15.5567C27.5931 15.5853 27.9314 15.2933 27.96 14.9046C27.999 14.3748 27.999 13.8094 27.999 13.2698V13.2329V13.2329V13.2328V13.2328C27.999 12.6384 27.999 11.9926 27.9263 11.3907ZM5.4742 11.5599C5.52094 11.1729 5.24509 10.8213 4.85807 10.7745C4.47105 10.7278 4.11942 11.0036 4.07268 11.3907C3.99998 11.9926 3.99999 12.6384 4 13.2329V13.2329V13.2698V13.2698C4 13.8094 4 14.3748 4.03896 14.9046C4.06755 15.2933 4.4059 15.5853 4.79468 15.5567C5.18346 15.5281 5.47545 15.1898 5.44686 14.801C5.41206 14.3278 5.4117 13.811 5.4117 13.2554C5.4117 12.6355 5.41265 12.0695 5.4742 11.5599ZM27.1471 17.3196C27.4077 17.0296 27.384 16.5834 27.0941 16.3227C26.8041 16.0621 26.3579 16.0859 26.0972 16.3758C25.9443 16.5459 25.6925 16.6957 25.1756 16.6957C24.7857 16.6957 24.4697 17.0118 24.4697 17.4016V19.1223C24.4697 19.5122 24.7857 19.8282 25.1756 19.8282C25.5654 19.8282 25.8814 19.5122 25.8814 19.1223V18.0362C26.391 17.9259 26.8163 17.6875 27.1471 17.3196ZM5.90172 16.3758C5.64111 16.0859 5.19482 16.0621 4.9049 16.3227C4.61499 16.5834 4.59124 17.0296 4.85185 17.3196C5.18265 17.6875 5.60792 17.9259 6.11756 18.0362V19.1223C6.11756 19.5122 6.43358 19.8282 6.82341 19.8282C7.21324 19.8282 7.52926 19.5122 7.52926 19.1223V17.4016C7.52926 17.0118 7.21324 16.6957 6.82341 16.6957C6.30649 16.6957 6.05467 16.5459 5.90172 16.3758ZM7.52926 21.4166C7.52926 21.0268 7.21324 20.7108 6.82341 20.7108C6.43358 20.7108 6.11756 21.0268 6.11756 21.4166V23.1374C6.11756 23.7131 6.25597 24.2586 6.50195 24.7404C6.67921 25.0876 7.10437 25.2254 7.45157 25.0481C7.79877 24.8708 7.93653 24.4457 7.75927 24.0985C7.61241 23.8108 7.52926 23.4848 7.52926 23.1374V21.4166ZM25.8814 21.4166C25.8814 21.0268 25.5654 20.7108 25.1756 20.7108C24.7857 20.7108 24.4697 21.0268 24.4697 21.4166V23.1374C24.4697 23.4848 24.3866 23.8108 24.2397 24.0985C24.0624 24.4457 24.2002 24.8708 24.5474 25.0481C24.8946 25.2254 25.3198 25.0876 25.497 24.7404C25.743 24.2586 25.8814 23.7131 25.8814 23.1374V21.4166ZM8.6857 25.0249C8.3385 24.8477 7.91334 24.9854 7.73608 25.3326C7.55882 25.6798 7.69658 26.105 8.04378 26.2822C8.52558 26.5282 9.07106 26.6666 9.64682 26.6666H11.5526C11.9424 26.6666 12.2585 26.3506 12.2585 25.9608C12.2585 25.5709 11.9424 25.2549 11.5526 25.2549H9.64682C9.29935 25.2549 8.97335 25.1718 8.6857 25.0249ZM23.9552 26.2822C24.3024 26.105 24.4401 25.6798 24.2629 25.3326C24.0856 24.9854 23.6605 24.8477 23.3133 25.0249C23.0256 25.1718 22.6996 25.2549 22.3521 25.2549H20.4464C20.0565 25.2549 19.7405 25.5709 19.7405 25.9608C19.7405 26.3506 20.0565 26.6666 20.4464 26.6666H22.3521C22.9279 26.6666 23.4734 26.5282 23.9552 26.2822ZM14.0937 25.2549C13.7039 25.2549 13.3878 25.5709 13.3878 25.9608C13.3878 26.3506 13.7039 26.6666 14.0937 26.6666H17.9053C18.2951 26.6666 18.6111 26.3506 18.6111 25.9608C18.6111 25.5709 18.2951 25.2549 17.9053 25.2549H14.0937ZM10.3533 4.07833C11.0863 4.07833 11.7627 4.30725 12.38 4.71314C12.7058 4.9273 13.1435 4.83684 13.3576 4.5111C13.5718 4.18536 13.4813 3.74769 13.1556 3.53354C12.3394 2.99692 11.3973 2.66663 10.3533 2.66663C9.65754 2.66663 9.02907 2.83058 8.49513 3.12615C8.15407 3.31496 8.03065 3.7445 8.21945 4.08556C8.40825 4.42662 8.83779 4.55004 9.17885 4.36124C9.49162 4.1881 9.88275 4.07833 10.3533 4.07833ZM16.7056 13.3726C16.7056 12.9827 16.3896 12.6667 15.9998 12.6667C15.6099 12.6667 15.2939 12.9827 15.2939 13.3726V16.7851H12C11.6102 16.7851 11.2941 17.1011 11.2941 17.4909C11.2941 17.8808 11.6102 18.1968 12 18.1968H15.2939V21.3334C15.2939 21.7232 15.6099 22.0392 15.9998 22.0392C16.3896 22.0392 16.7056 21.7232 16.7056 21.3334V18.1968H20C20.3898 18.1968 20.7058 17.8808 20.7058 17.4909C20.7058 17.1011 20.3898 16.7851 20 16.7851H16.7056V13.3726Z"
                  fill="white"
                />
              </svg>
            </div>
            <div className="flex flex-col gap-[6px] w-[203px] h-[51px]">
              {data?.submissions_count !== undefined && (
                <span className="text-primary !text-[18px]">
                  {data?.submissions_count}
                </span>
              )}
              {data?.submissions_count === undefined && (
                <Skeleton className="!w-[132px]" />
              )}
              <span className="text-secondary !leading-[21px]">
                Submissions
              </span>
            </div>
            <Button
              className={cn({
                invisible: !data?.submissions_count,
              })}
              onClick={() => {
                setPopup(true);
                setState(17);
              }}
              secondary
              hoverColor
            >
              View
            </Button>
          </div>
        </div>
      </div>
    </SkeletonTheme>
  );
}
export default PillCards;
